import { PRIMARY_CONTACT_NAME_SORT_COLUMN } from "shared";

import { ActionsTable } from "../../../Actions/ActionsTable";

export function ContactActivity() {
  return (
    <ActionsTable
      omitColumns={ [ `contact`, PRIMARY_CONTACT_NAME_SORT_COLUMN ] }
      smallTabs
    />
  );
}
